/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bpm: NonNullable<unknown> }} Ui_Laps_Efforts_BpmInputs */

const en_ui_laps_efforts_bpm = /** @type {(inputs: Ui_Laps_Efforts_BpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bpm} bpm`)
};

const de_ui_laps_efforts_bpm = /** @type {(inputs: Ui_Laps_Efforts_BpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bpm} bpm`)
};

/**
* | output |
* | --- |
* | "{bpm} bpm" |
*
* @param {Ui_Laps_Efforts_BpmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_bpm = /** @type {((inputs: Ui_Laps_Efforts_BpmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_BpmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_bpm(inputs)
	return de_ui_laps_efforts_bpm(inputs)
});